'use strict';

import { PlanCollection } from '../Collections/PlanCollection';
import { Plan } from '../Entities/Plan';
import { CoreRepository } from './CoreRepository';

export class PlanRepository extends CoreRepository {
  public getUserPlanTypes(userId: number, options: object = {}) {
    return this.webAPI.getUserPlanTypes(userId, options).then((response) => {
      return response;
    });
  }

  public getUserPlans(userId: number, type: string, options: object = {}) {
    return this.webAPI.getUserPlans(userId, type, options).then((response) => {
      const collection = new PlanCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new Plan();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getPlans(options: object = {}) {
    return this.webAPI.getPlans(options).then((response) => {
      const collection = new PlanCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new Plan();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }
}
